module.exports = __webpack_public_path__ + "img/loyalty-by-sable.43d9b219.svg";